import {
  ESearchLevel,
  IPolygonProperties,
  ITileset,
} from '../../../types-library/src'

import { IHttpResponse } from '../types'
import { hexaServiceAPI } from '@wiggot/apis'
import { mapboxApi } from '../apis'

const MAPBOX_API_KEY = process.env.MAPBOX_API_KEY ?? ''

export const getPolygon = async (params: {
  center: {
    lat: number
    lng: number
  }
  searchLevel: ESearchLevel
}): Promise<IHttpResponse<{ id: string }>> => {
  try {
    const {
      center: { lat, lng },
      searchLevel,
    } = params

    // hexaServiceAPI.get ya devuelve el body de la respuesta (no el
    // AxiosResponse completo), a diferencia del hexaBasicServiceAPI que
    // usaba monopolio-ui.
    const response: any = await hexaServiceAPI.get<any>(
      `/lookup?level=${searchLevel}&latitude=${lat}&longitude=${lng}`
    )

    return {
      isSuccess: true,
      data: response?.data,
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error: {
        code: error?.status,
        message: error?.data?.message,
      },
    }
  }
}

/**
 * This service is used to get the tilesets
 * @returns {Promise<HttpResponse<ITileset>>}
 */
export const getPolygonTileSets = async (): Promise<
  IHttpResponse<ITileset[]>
> => {
  try {
    const res: any = await hexaServiceAPI.get<any>(`/tilesets`)
    return {
      isSuccess: true,
      data: res?.data,
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error: {
        code: error?.status,
        message: error?.data?.message,
      },
    }
  }
}

export const getPolygonsFromVectorTiles = async (params: {
  center: {
    lat: number
    lng: number
  }
  sources: string[]
}): Promise<IHttpResponse<IPolygonProperties[]>> => {
  try {
    const {
      center: { lat, lng },
      sources,
    } = params

    const radius = 30

    if (!sources?.length) {
      return {
        isSuccess: false,
        error: {
          code: 404,
          message: 'No tile Object was found',
        },
      }
    }

    const tiles = [...sources.map((source) => `davpach.${source}`)].join(',')

    const response = await mapboxApi.get<any>(
      `/${tiles}/tilequery/${lng},${lat}.json?radius=${radius}&geometry=polygon&access_token=${MAPBOX_API_KEY}`
    )

    const features = response?.data?.features || []

    return {
      isSuccess: true,
      data: features,
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error: { message: error?.message, code: error?.code },
    }
  }
}
